import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { authEmailSelector } from 'store/auth/selectors';
import { useUsersQuery } from 'services/admin-bff-sdk/generated';

export interface UserRole {
    newsroom: string;
    roleType: string;
}

export const useUserRoles = (): UserRole[] => {
    const email = useSelector(authEmailSelector);
    const { data } = useUsersQuery({ query: email });
    return useMemo(
        () => data?.users[0]?.roles?.map(({ newsroom, roleType }) => ({ newsroom, roleType })) || [],
        [data?.users]
    );
};
